import React, { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { useTheme } from 'styled-components'
import { useTranslation } from 'react-i18next'
import * as DropdownMenu from '@radix-ui/react-dropdown-menu'
import styles from '../Dropdowns.module.scss'
import ModalActions from 'reducers/Modal'
import { DropdownTrigger, UserWrapper } from './UserDropdown.styles'
import { Logout } from '@dsny/dsny-component-library/icons'
import { getAvatarInfo } from '../../../utils/avatarHelpers'
import { Tonality } from '@dsny/dsny-component-library'
import { useMobileMediaQuery } from 'utils/hooks/useMediaQueries'

const UserDropdown = ({}) => {
  const theme = useTheme()
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const navigate = useNavigate()
  const isMobile = useMobileMediaQuery()
  const profile = useSelector((state) => state.profile.profile)

  const handleNavigateToAccount = () => {
    navigate('/account/profile')
  }

  const handleNavigateToMyNetwork = () => {
    navigate('/account/my-network')
  }

  const handleSignout = useCallback(() => {
    dispatch(ModalActions.toggleSignoutModal())
  }, [])

  const email = profile?.emails?.[0] || ''
  const firstName = profile?.firstname || ''
  const lastName = profile?.lastname || ''

  const { initials, color } = getAvatarInfo(firstName, lastName, email)

  return (
    <UserWrapper>
      <DropdownMenu.Root>
        <DropdownTrigger
          style={{
            justifySelf: 'center',
            border: 'none',
            paddingLeft: isMobile ? '6px' : 0
          }}
          onClick={() => {
            if (isMobile) {
              navigate('/account')
            }
          }}
        >
          <Tonality.Avatar color={color}>{initials}</Tonality.Avatar>
        </DropdownTrigger>

        {!isMobile && (
          <DropdownMenu.Portal>
            <DropdownMenu.Content
              side="bottom"
              align="end"
              style={{
                background: theme.colors.neutralW20,
                color: theme.colors.neutralW100,
                padding: '5px 0',
                height: 'auto',
                maxHeight: 216,
                overflow: 'auto',
                border: `0.5px solid ${theme.colors.neutralW30}`
              }}
              className={`${styles.DropdownMenuContent} ${styles.UserMenuContent}`}
              sideOffset={5}
              avoidCollisions
              collisionPadding={20}
            >
              <DropdownMenu.Item
                className={styles.DropdownMenuItem}
                onClick={handleNavigateToAccount}
              >
                {t('home.profile')}
              </DropdownMenu.Item>

              <DropdownMenu.Item
                className={styles.DropdownMenuItem}
                onClick={handleNavigateToMyNetwork}
              >
                {t('home.my-network')}
              </DropdownMenu.Item>

              <DropdownMenu.Item
                className={styles.DropdownMenuItem}
                onClick={() => navigate('/account/management')}
              >
                {t('home.account-management')}
              </DropdownMenu.Item>

              <DropdownMenu.Item
                className={styles.DropdownMenuItem}
                onClick={() => navigate('/account/settings-preferences')}
              >
                {t('home.settings-preferences')}
              </DropdownMenu.Item>

              <DropdownMenu.Separator
                style={{ height: 1, background: theme.colors.neutralW30 }}
              />

              <DropdownMenu.Item
                className={styles.DropdownMenuItem}
                onClick={handleSignout}
              >
                <Logout
                  width={20}
                  height={20}
                  color={theme.colors.neutralW80}
                  style={{ marginRight: '8px' }}
                />
                {t('home.sign-out')}
              </DropdownMenu.Item>
            </DropdownMenu.Content>
          </DropdownMenu.Portal>
        )}
      </DropdownMenu.Root>
    </UserWrapper>
  )
}

export default UserDropdown
